import { AxiosError } from 'axios';
import type { DefaultGetResponse } from '~/App/Api/rest';
import { useQuery, UseQueryOptions } from 'react-query';
import { fetchTestimonial } from '../Modules/Testimonials/Actions/respondentsAction';
import { GetTestimonialResponse } from '~/types/api/testimonials';
import usePagination, { PaginationOptions } from '~/react-hooks/usePagination';
import { TestimonialRespondentsMedia } from '~/types/models/testimonial';
import { testimonialApiPath } from '../Modules/Testimonials/Actions/testimonialActions';

export const queryKeys = {
  all: ['testimonials'],
  lists: () => [...queryKeys.all, 'list'] as const,
  details: () => [...queryKeys.all, 'detail'] as const,
  detail: (uuid: string) => [...queryKeys.details(), uuid] as const,
};

export interface TestimonialHookParams {
  testimonialUuid: string;
  options?: UseQueryOptions<
    DefaultGetResponse<GetTestimonialResponse>,
    AxiosError
  >;
}

export const useTestimonial = ({
  testimonialUuid,
  options,
}: TestimonialHookParams) =>
  useQuery<DefaultGetResponse<GetTestimonialResponse>, AxiosError>(
    queryKeys.detail(testimonialUuid),
    () => fetchTestimonial({ testimonialUuid }),
    options
  );

export function useTestimonialMediaPagination(params: PaginationOptions) {
  return usePagination<TestimonialRespondentsMedia>(
    `${testimonialApiPath}/media`,
    params
  );
}
